/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ionic-angular/components/label/label';
import * as import2 from 'ionic-angular/config/config';
import * as import3 from './reorder.ngfactory';
import * as import4 from 'ionic-angular/components/item/reorder';
import * as import5 from '@angular/common';
import * as import6 from 'ionic-angular/components/item/item';
import * as import7 from 'ionic-angular/util/form';
import * as import8 from 'ionic-angular/components/item/item-reorder';
const styles_Item:any[] = ([] as any[]);
export const RenderType_Item:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_Item,
  data: {}
}
);
function View_Item_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'ion-label',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(16384,[[
        1,
        4
      ]
    ],0,import1.Label,[
      import2.Config,
      import0.ElementRef,
      import0.Renderer,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵncd((null as any),2)
  ]
  ,(null as any),(null as any));
}
function View_Item_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'ion-reorder',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_Reorder_0,import3.RenderType_Reorder)),
    import0.ɵdid(49152,(null as any),0,import4.Reorder,[import0.ElementRef],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export function View_Item_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    import0.ɵqud(671088640,1,{viewLabel: 0}),
    import0.ɵncd((null as any),0),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'item-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'input-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_Item_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵncd((null as any),3),
    import0.ɵncd((null as any),4),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_Item_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'button-effect'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    var co:import6.Item = v.component;
    const currVal_0:any = co._viewLabel;
    ck(v,6,0,currVal_0);
    const currVal_1:any = co._hasReorder;
    ck(v,10,0,currVal_1);
  },(null as any));
}
function View_Item_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'ion-list-header',[[
        'class',
        'item'
      ]
    ],(null as any),(null as any),(null as any),View_Item_0,RenderType_Item)),
    import0.ɵdid(1097728,(null as any),3,import6.Item,[
      import7.Form,
      import2.Config,
      import0.ElementRef,
      import0.Renderer,
      [
        2,
        import8.ItemReorder
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵqud(335544320,1,{contentLabel: 0}),
    import0.ɵqud(603979776,2,{_buttons: 1}),
    import0.ɵqud(603979776,3,{_icons: 1})
  ]
  ,(null as any),(null as any));
}
export const ItemNgFactory:import0.ComponentFactory<import6.Item> = import0.ɵccf('ion-list-header,ion-item,[ion-item],ion-item-divider',import6.Item,View_Item_Host_0,{
  color: 'color',
  mode: 'mode'
}
,{},[
  '[item-start],[item-left],ion-checkbox:not([item-end]):not([item-right])',
  'ion-label',
  '*',
  'ion-select,ion-input,ion-textarea,ion-datetime,ion-range,[item-content]',
  '[item-end],[item-right],ion-radio,ion-toggle'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ionic-angular/components/item/item.ngfactory.ts